var _mask, _path, _path2, _path3, _g, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_21598_21581",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1052 3C17.8852 3 16.8651 3.8559 16.6126 5H2.47826C2.21412 5 2 5.21412 2 5.47826C2 11.2893 6.71074 16 12.5217 16H17V14C17 12.8954 17.8954 12 19 12H24C25.1046 12 26 12.8954 26 14V16H30.4783C36.2893 16 41 11.2893 41 5.47826C41 5.21412 40.7859 5 40.5217 5H26.3874C26.1349 3.8559 25.1148 3 23.8948 3H19.1052ZM12.4091 18.0001H17V20C17 21.1046 17.8954 22 19 22H24C25.1046 22 26 21.1046 26 20V18.0001H30.5909C34.3823 18.0001 37.7765 16.2998 40.0527 13.6201V30.0001C40.0527 31.6569 38.7095 33.0001 37.0527 33.0001H5.94739C4.29054 33.0001 2.94739 31.6569 2.94739 30.0001V13.6202C5.22356 16.2998 8.61777 18.0001 12.4091 18.0001ZM20 14C19.4477 14 19 14.4477 19 15V19C19 19.5523 19.4477 20 20 20H23C23.5523 20 24 19.5523 24 19V15C24 14.4477 23.5523 14 23 14H20Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1052 3C17.8852 3 16.8651 3.8559 16.6126 5H2.47826C2.21412 5 2 5.21412 2 5.47826C2 11.2893 6.71074 16 12.5217 16H17V14C17 12.8954 17.8954 12 19 12H24C25.1046 12 26 12.8954 26 14V16H30.4783C36.2893 16 41 11.2893 41 5.47826C41 5.21412 40.7859 5 40.5217 5H26.3874C26.1349 3.8559 25.1148 3 23.8948 3H19.1052ZM12.4091 18.0001H17V20C17 21.1046 17.8954 22 19 22H24C25.1046 22 26 21.1046 26 20V18.0001H30.5909C34.3823 18.0001 37.7765 16.2998 40.0527 13.6201V30.0001C40.0527 31.6569 38.7095 33.0001 37.0527 33.0001H5.94739C4.29054 33.0001 2.94739 31.6569 2.94739 30.0001V13.6202C5.22356 16.2998 8.61777 18.0001 12.4091 18.0001ZM20 14C19.4477 14 19 14.4477 19 15V19C19 19.5523 19.4477 20 20 20H23C23.5523 20 24 19.5523 24 19V15C24 14.4477 23.5523 14 23 14H20Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1052 3C17.8852 3 16.8651 3.8559 16.6126 5H2.47826C2.21412 5 2 5.21412 2 5.47826C2 11.2893 6.71074 16 12.5217 16H17V14C17 12.8954 17.8954 12 19 12H24C25.1046 12 26 12.8954 26 14V16H30.4783C36.2893 16 41 11.2893 41 5.47826C41 5.21412 40.7859 5 40.5217 5H26.3874C26.1349 3.8559 25.1148 3 23.8948 3H19.1052ZM12.4091 18.0001H17V20C17 21.1046 17.8954 22 19 22H24C25.1046 22 26 21.1046 26 20V18.0001H30.5909C34.3823 18.0001 37.7765 16.2998 40.0527 13.6201V30.0001C40.0527 31.6569 38.7095 33.0001 37.0527 33.0001H5.94739C4.29054 33.0001 2.94739 31.6569 2.94739 30.0001V13.6202C5.22356 16.2998 8.61777 18.0001 12.4091 18.0001ZM20 14C19.4477 14 19 14.4477 19 15V19C19 19.5523 19.4477 20 20 20H23C23.5523 20 24 19.5523 24 19V15C24 14.4477 23.5523 14 23 14H20Z",
    fill: "url(#paint0_linear_21598_21581)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6126 5V6H17.416L17.5891 5.2155L16.6126 5ZM17 16V17H18V16H17ZM26 16H25V17H26V16ZM26.3874 5L25.4109 5.2155L25.584 6H26.3874V5ZM17 18.0001H18V17.0001H17V18.0001ZM26 18.0001V17.0001H25V18.0001H26ZM40.0527 13.6201H41.0527V10.8982L39.2905 12.9727L40.0527 13.6201ZM2.94739 13.6202L3.70954 12.9728L1.94739 10.8983V13.6202H2.94739ZM17.5891 5.2155C17.7426 4.51984 18.3644 4 19.1052 4V2C17.406 2 15.9875 3.19196 15.6361 4.7845L17.5891 5.2155ZM2.47826 6H16.6126V4H2.47826V6ZM3 5.47826C3 5.76641 2.76641 6 2.47826 6V4C1.66184 4 1 4.66184 1 5.47826H3ZM12.5217 15C7.26303 15 3 10.737 3 5.47826H1C1 11.8415 6.15846 17 12.5217 17V15ZM17 15H12.5217V17H17V15ZM16 14V16H18V14H16ZM19 11C17.3431 11 16 12.3431 16 14H18C18 13.4477 18.4477 13 19 13V11ZM24 11H19V13H24V11ZM27 14C27 12.3431 25.6569 11 24 11V13C24.5523 13 25 13.4477 25 14H27ZM27 16V14H25V16H27ZM30.4783 15H26V17H30.4783V15ZM40 5.47826C40 10.737 35.737 15 30.4783 15V17C36.8415 17 42 11.8415 42 5.47826H40ZM40.5217 6C40.2336 6 40 5.76641 40 5.47826H42C42 4.66184 41.3382 4 40.5217 4V6ZM26.3874 6H40.5217V4H26.3874V6ZM23.8948 4C24.6356 4 25.2574 4.51984 25.4109 5.2155L27.3639 4.7845C27.0124 3.19196 25.594 2 23.8948 2V4ZM19.1052 4H23.8948V2H19.1052V4ZM17 17.0001H12.4091V19.0001H17V17.0001ZM18 20V18.0001H16V20H18ZM19 21C18.4477 21 18 20.5523 18 20H16C16 21.6569 17.3431 23 19 23V21ZM24 21H19V23H24V21ZM25 20C25 20.5523 24.5523 21 24 21V23C25.6569 23 27 21.6569 27 20H25ZM25 18.0001V20H27V18.0001H25ZM30.5909 17.0001H26V19.0001H30.5909V17.0001ZM39.2905 12.9727C37.1962 15.4382 34.0765 17.0001 30.5909 17.0001V19.0001C34.6881 19.0001 38.3568 17.1613 40.8148 14.2675L39.2905 12.9727ZM41.0527 30.0001V13.6201H39.0527V30.0001H41.0527ZM37.0527 34.0001C39.2618 34.0001 41.0527 32.2092 41.0527 30.0001H39.0527C39.0527 31.1046 38.1572 32.0001 37.0527 32.0001V34.0001ZM5.94739 34.0001H37.0527V32.0001H5.94739V34.0001ZM1.94739 30.0001C1.94739 32.2092 3.73825 34.0001 5.94739 34.0001V32.0001C4.84282 32.0001 3.94739 31.1046 3.94739 30.0001H1.94739ZM1.94739 13.6202V30.0001H3.94739V13.6202H1.94739ZM12.4091 17.0001C8.92356 17.0001 5.80383 15.4383 3.70954 12.9728L2.18524 14.2676C4.64329 17.1613 8.31197 19.0001 12.4091 19.0001V17.0001ZM20 15V13C18.8954 13 18 13.8954 18 15H20ZM20 19V15H18V19H20ZM20 19H18C18 20.1046 18.8954 21 20 21V19ZM23 19H20V21H23V19ZM23 19V21C24.1046 21 25 20.1046 25 19H23ZM23 15V19H25V15H23ZM23 15H25C25 13.8954 24.1046 13 23 13V15ZM20 15H23V13H20V15Z",
    fill: "url(#paint1_radial_21598_21581)",
    mask: "url(#path-1-inside-1_21598_21581)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_21598_21581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5279 51.7639L41 58L53.4721 51.7639C56.86 50.07 59 46.6074 59 42.8197V21.5556C59 20.6406 58.3823 19.8469 57.4863 19.6615C54.7294 19.0911 48.4784 18 41 18C33.5216 18 27.2706 19.0911 24.5137 19.6615C23.6177 19.8469 23 20.6406 23 21.5556V42.8197C23 46.6074 25.14 50.07 28.5279 51.7639Z",
    fill: "url(#paint2_linear_21598_21581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5279 51.7639L41 58L53.4721 51.7639C56.86 50.07 59 46.6074 59 42.8197V21.5556C59 20.6406 58.3823 19.8469 57.4863 19.6615C54.7294 19.0911 48.4784 18 41 18C33.5216 18 27.2706 19.0911 24.5137 19.6615C23.6177 19.8469 23 20.6406 23 21.5556V42.8197C23 46.6074 25.14 50.07 28.5279 51.7639Z",
    fill: "url(#paint3_radial_21598_21581)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 57.441L28.7515 51.3167C25.533 49.7075 23.5 46.418 23.5 42.8197V21.5556C23.5 20.8665 23.962 20.2862 24.615 20.1511C27.3518 19.5849 33.5669 18.5 41 18.5C48.4331 18.5 54.6482 19.5849 57.385 20.1511C58.038 20.2862 58.5 20.8665 58.5 21.5556V42.8197C58.5 46.418 56.467 49.7075 53.2485 51.3167L41 57.441Z",
    stroke: "url(#paint4_radial_21598_21581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 57.441L28.7515 51.3167C25.533 49.7075 23.5 46.418 23.5 42.8197V21.5556C23.5 20.8665 23.962 20.2862 24.615 20.1511C27.3518 19.5849 33.5669 18.5 41 18.5C48.4331 18.5 54.6482 19.5849 57.385 20.1511C58.038 20.2862 58.5 20.8665 58.5 21.5556V42.8197C58.5 46.418 56.467 49.7075 53.2485 51.3167L41 57.441Z",
    stroke: "url(#paint5_radial_21598_21581)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7071 35.2071L41 38.5L48.7929 30.7071C49.1834 30.3166 49.8166 30.3166 50.2071 30.7071L51.777 32.277C52.1737 32.6737 52.1665 33.319 51.7611 33.7068L41.6811 43.3486C41.2986 43.7144 40.6972 43.7189 40.3094 43.3587L34.7604 38.2061C34.3451 37.8204 34.333 37.167 34.7338 36.7662L36.2929 35.2071C36.6834 34.8166 37.3166 34.8166 37.7071 35.2071Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7071 34.2071L40 37.5L47.7929 29.7071C48.1834 29.3166 48.8166 29.3166 49.2071 29.7071L50.777 31.277C51.1737 31.6737 51.1665 32.319 50.7611 32.7068L40.6811 42.3486C40.2986 42.7144 39.6972 42.7189 39.3094 42.3587L33.7604 37.2061C33.3451 36.8204 33.333 36.167 33.7338 35.7662L35.2929 34.2071C35.6834 33.8166 36.3166 33.8166 36.7071 34.2071Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21598_21581",
    x: 17,
    y: 12,
    width: 48,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21581"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21581",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21598_21581",
    x1: 2,
    y1: 3,
    x2: 14.5644,
    y2: 35.6675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_21598_21581",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.5 -11.4231) rotate(48.262) scale(39.4307 41.9846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21598_21581",
    x1: 24.125,
    y1: 19,
    x2: 44.4304,
    y2: 55.0688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_21598_21581",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.125 19) scale(33.75 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_21598_21581",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.25 33.5) rotate(31.3633) scale(23.0564 21.9692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_21598_21581",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.25 17) rotate(128.22) scale(12.7285 13.1692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.323aa6dd1428fab48f461e7d3462e011.svg";
export { ForwardRef as ReactComponent };